import React from "react";

const AllCash = React.createContext()

export default AllCash